import { useEffect, useState } from 'react';
import { Table, Select, message, Tag, Space, Image } from 'antd';
import api from '../../api/axios';
import './admin.css';

const BASE = (process.env.REACT_APP_URL || 'http://127.0.0.1:8000/').replace(/\/$/, '');
const STATUS = {
  pending: { t: 'Kutilmoqda', c: 'orange' }, reviewed: { t: "Ko'rildi", c: 'blue' },
  resolved: { t: 'Hal qilindi', c: 'green' }, rejected: { t: 'Rad etildi', c: 'red' },
};

export default function AdminReports() {
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [statusFilter, setStatusFilter] = useState(null);

  const fetchData = async (p = page) => {
    setLoading(true);
    try {
      const params = { page: p, limit: 20 };
      if (statusFilter) params.status = statusFilter;
      const r = await api.get('/admingov/reports', { params });
      setData(r.data.data); setTotal(r.data.total);
    } catch { message.error('Xatolik'); }
    setLoading(false);
  };

  useEffect(() => { setPage(1); fetchData(1); /* eslint-disable-next-line */ }, [statusFilter]);

  const changeStatus = async (id, status) => {
    try {
      await api.put(`/admingov/reports/${id}`, { status });
      message.success('Status yangilandi'); fetchData();
    } catch { message.error('Xatolik'); }
  };

  const columns = [
    { title: 'ID', dataIndex: 'id', width: 50 },
    { title: 'Vendor nomi', dataIndex: 'vendor_name', render: v => <span style={{ fontWeight: 600 }}>{v || '—'}</span> },
    { title: 'Xizmat turi', dataIndex: 'service_type_name', render: v => v ? <Tag>{v}</Tag> : '—' },
    { title: 'Viloyat', dataIndex: 'region', render: v => v || '—' },
    { title: 'Tafsilot', dataIndex: 'details', ellipsis: true, render: v => v || '—' },
    { title: 'Telefon', dataIndex: 'reporter_phone', render: v => v || '—' },
    {
      title: 'Dalillar', dataIndex: 'evidence',
      render: (ev) => ev?.length ? (
        <Image.PreviewGroup>
          <Space>{ev.slice(0, 4).map((e, i) => <Image key={i} width={36} height={36} style={{ objectFit: 'cover', borderRadius: 6 }} src={`${BASE}/${e.file_path}`} />)}</Space>
        </Image.PreviewGroup>
      ) : '—',
    },
    {
      title: 'Status', dataIndex: 'status',
      render: (s, r) => (
        <Select size="small" value={s} onChange={v => changeStatus(r.id, v)} style={{ width: 130 }}
          options={Object.entries(STATUS).map(([k, v]) => ({ label: v.t, value: k }))} />
      ),
    },
    { title: 'Sana', dataIndex: 'created_at', render: v => v ? new Date(v).toLocaleDateString('uz-UZ') : '—' },
  ];

  return (
    <div>
      <div className="admin-toolbar">
        <Select placeholder="Status bo'yicha filtrlash" allowClear style={{ width: 200 }} value={statusFilter} onChange={setStatusFilter}
          options={Object.entries(STATUS).map(([k, v]) => ({ label: v.t, value: k }))} />
        <span style={{ marginLeft: 'auto', color: 'var(--a-muted)', fontSize: 13 }}>Jami: <b>{total}</b></span>
      </div>
      <div className="admin-table-card">
        <Table dataSource={data} columns={columns} rowKey="id" loading={loading} size="middle" scroll={{ x: 1000 }}
          pagination={{ current: page, total, pageSize: 20, showSizeChanger: false,
            onChange: p => { setPage(p); fetchData(p); } }} />
      </div>
    </div>
  );
}
